/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspage_Error_Slug_Reserved1Inputs */

const vi_cmspage_error_slug_reserved1 = /** @type {(inputs: Cmspage_Error_Slug_Reserved1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đường dẫn này trùng một trang có sẵn của website — đổi đường dẫn khác.`)
};

/**

* @param {Cmspage_Error_Slug_Reserved1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspage_error_slug_reserved1 = /** @type {((inputs?: Cmspage_Error_Slug_Reserved1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspage_Error_Slug_Reserved1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspage_error_slug_reserved1(inputs)
});
export { cmspage_error_slug_reserved1 as "cmsPage_error_slug_reserved" }